define('presentation/common/conversationImagesGrid/conversationImagesGridPresentationObject',[], function() {
    return function() {
        const self = this;

        self.images = ko.observableArray([]);
    };
});
